import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api/api";

export default function ForceLoginPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { authToken } = location.state || {};
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [otp, setOtp] = useState("");
    const [otpMessage, setOtpMessage] = useState(null);
    const [otpMessageType, setOtpMessageType] = useState(""); // success | error
    const [redirecting, setRedirecting] = useState(false);

    const [showOtpModal, setShowOtpModal] = useState(false);
    const [loading, setLoading] = useState(false);

   const sendOtp = async () => {
  if (!userName || !password || !email) return;

  setLoading(true);
  setOtpMessage(null);

  try {
    const payload = {
      usrId: "",
      userName: userName,
      userpwd: password,
      emailId: email,
      ipAddress: "string",
      currentAuthToken: authToken || ""
    };

    const res = await api.ForceSignOutUser(payload);

    // 🔑 Extract backend message safely
    const message =
      res?.forceSignOutResult?.Message ||
      res?.Message ||
      "";

    // ❌ Invalid credentials → DO NOT show OTP popup
    if (message.toLowerCase().includes("invalid")) {
      setOtpMessageType("error");
      setOtpMessage(message);
      setShowOtpModal(false);
      return;
    }

    // ✅ OTP sent successfully
    setOtpMessageType(null);
    setOtpMessage(null);
    setShowOtpModal(true);

  } catch (err) {
    setOtpMessageType("error");
    setOtpMessage("Failed to send OTP. Please try again.");
    setShowOtpModal(false);
  } finally {
    setLoading(false);
  }
};

 const confirmOtp = async () => {
  if (!otp) return;

  setLoading(true);
  setOtpMessage(null);

  try {
    const res = await api.ForceSignOutVerifyOtp(userName, otp);

    const msg =
      typeof res === "string"
        ? res
        : res?.message || "";

    if (msg.toLowerCase().includes("verified")) {
      setOtpMessageType("success");
      setOtpMessage(
        "Your previous session has been terminated successfully. Please sign in again using your username and password."
      );

      setRedirecting(true);

      setTimeout(() => {
        setShowOtpModal(false);
        navigate("/login", { replace: true });
      }, 2500);

    } else {
      setOtpMessageType("error");
      setOtpMessage(msg || "Invalid or expired OTP.");
    }

  } catch (err) {
    setOtpMessageType("error");
    setOtpMessage("OTP verification failed. Please try again.");
  }

  setLoading(false);
};



    return (
        <div className="relative h-screen w-screen flex items-center justify-center">

            {/* Background */}
            <div
                className="absolute inset-0"
                style={{
                    background: "linear-gradient(135deg, var(--base-200), var(--base-100))",
                }}
            />

            {/* Card */}
            <div className="glass-card max-w-md w-full z-10 py-5 px-6 animate-fade-in">

                <h2
                    className="text-2xl font-bold text-center mb-2"
                    style={{
                        background:
                            "linear-gradient(135deg, var(--primary), var(--primary-focus))",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                    }}
                >
                    Force Sign In
                </h2>

                <p className="text-sm text-center text-gray-600 mb-4">
                    This will terminate the existing session after verification
                </p>

                {/* Username */}
                <div className="mb-3">
                    <label className="text-sm font-semibold">Username</label>
                    <input
                        className="input-professional h-10 text-sm"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                    />
                </div>

                {/* Password */}
                <div className="mb-3">
                    <label className="text-sm font-semibold">Password</label>
                    <input
                        type="password"
                        className="input-professional h-10 text-sm"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                {/* Email */}
                <div className="mb-3">
                    <label className="text-sm font-semibold">Registered Email</label>
                    <input
                        type="email"
                        className="input-professional h-10 text-sm"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </div>

                {/* Send OTP */}
                <button
                    onClick={sendOtp}
                    disabled={loading}
                    className="btn-professional w-full h-11 mt-2"
                >
                    {loading ? "Sending OTP..." : "Send OTP"}
                </button>
                {otpMessage && !showOtpModal && (
  <div className="mt-3 p-2 text-sm text-center rounded-lg bg-red-100 text-red-700">
    {otpMessage}
  </div>
)}

                <div className="mt-4 text-center">
                    <button
                        onClick={() => navigate("/login")}
                        className="text-sm text-blue-600 hover:underline"
                    >
                        Back to Login
                    </button>
                </div>
            </div>

            {/* 🔐 OTP MODAL */}
            {showOtpModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl shadow-xl p-5 w-full max-w-sm animate-fade-in">

                        <h3 className="text-lg font-semibold text-center mb-1">
                            OTP Verification
                        </h3>

                        <p className="text-sm text-center text-gray-600 mb-4">
                            Enter the OTP sent to your registered email address
                        </p>

                        <input
                            className="input-professional h-10 text-sm mb-3"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter OTP"
                            disabled={redirecting}
                        />

                        {/* ✅ INLINE NOTIFICATION */}
                        {otpMessage && (
                            <div
                                className={`mb-3 p-2 rounded-lg text-sm text-center
            ${otpMessageType === "success"
                                        ? "bg-green-100 text-green-700"
                                        : "bg-red-100 text-red-700"
                                    }`}
                            >
                                {otpMessage}
                            </div>
                        )}

                        <div className="flex justify-end gap-2">
                            <button
                                disabled={loading || redirecting}
                                onClick={() => setShowOtpModal(false)}
                                className="px-4 py-2 text-sm border rounded-lg hover:bg-gray-100"
                            >
                                Cancel
                            </button>

                            <button
                                disabled={loading || redirecting}
                                onClick={confirmOtp}
                                className="px-4 py-2 text-sm rounded-lg bg-green-600 text-white hover:bg-green-700"
                            >
                                {redirecting ? "Redirecting..." : "Verify OTP"}
                            </button>
                        </div>

                    </div>
                </div>
            )}

        </div>
    );
}
